import { ChartBot } from "./ChartBot";
import BotOverviewXenoArc from "./BotOverviewXenoArc";
import BotOverviewRebalance from "./BotOverviewRebalance";
import BotOverviewDCA from "./BotOverviewDCA";
import { useBot } from "../../context/botContext";
import XenoTradeMarkersChart from "./TradeMarkerChart";
import { PerformanceSection } from "../dashboard/PerformanceSection";
import { ProfitTrendsChart } from "../dashboard/ProfitTrendsChart";
// import buyIcon from "../../assets/marker/buy_marker.png"
// import sellIcon from "../../assets/marker/sell_marker.png"

export const ChartAndListBotActive = () => {
  const {
    strategyLists,
    loadingBotLists,
    botDetail,
    botLists,
    selectedBot,
    setSelectedBot,
    loadingBotDetail,
    setSelectedStrategy,
    setOpenDialogBot,
    dataBotProfits,
  } = useBot();

  const handleBotClick = (bot) => {
    setSelectedBot(bot);
  };

  const RenderBotOverview = () => {
    const strategy = selectedBot?.bot_strategy?.toLowerCase();

    const handleOpenEdit = () => {
      setOpenDialogBot("step-bot-2-edit");
      setSelectedStrategy({
        ...strategyLists.find(
          (stg) => stg?.bot_name.toLowerCase() === strategy,
        ),
        active_bot_id: selectedBot?.id,
      });
    };

    if (["xenoarc", "xeno arc", "xeno bot v3", "grid"].includes(strategy)) {
      return (
        <BotOverviewXenoArc
          selectedBot={botDetail}
          loading={loadingBotDetail}
          setOpenDialog={setOpenDialogBot}
          handleOpenEdit={handleOpenEdit}
        />
      );
    }

    switch (strategy) {
      case "rebalance":
        return (
          <BotOverviewRebalance
            selectedBot={botDetail}
            loading={loadingBotDetail}
            setOpenDialog={setOpenDialogBot}
          />
        );
      case "dca":
        return (
          <BotOverviewDCA
            selectedBot={botDetail}
            loading={loadingBotDetail}
            setOpenDialog={setOpenDialogBot}
            handleOpenEdit={handleOpenEdit}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className=" w-full flex flex-col gap-4">
      {!!botLists.length ? (
        <>
          <div className="bg-white rounded-xl md:py-4 md:pr-4 md:pl-3 mb-3">
            <XenoTradeMarkersChart
              botId={selectedBot?.id}
              // timeframe="1M"
              height={450}
              pairSymbol={botDetail?.coin_name.split("/").join("")}
            />
          </div>
          <div className=" bg-white rounded-xl md:pt-6 ">
            {/* <ChartBot /> */}
            <ProfitTrendsChart
              dashboard={{
                profit_trends: dataBotProfits ?? [],
              }}
              loading={loadingBotDetail}
            />
          </div>
          {RenderBotOverview()}
        </>
      ) : (
        // NO BOT ACTIVE
        <div className="w-full h-[35vh] lg:h-[85vh] flex flex-col justify-center items-center bg-white rounded-xl">
          <img
            src={"/images/icons/icon_no_bot_activated.svg"}
            alt=""
            className="w-[140px] h-[140px] lg:w-[200px] lg:h-[200px]"
          />
          <p className="text-[#697077] text-base text-center w-[80%] lg:w-full">
            Not activated yet? Start your bot and begin trading instantly.
          </p>
        </div>
      )}
    </div>
  );
};
